import { Suspense } from 'react';
import { InboxClient } from './inbox-client';

export const metadata = { title: 'Inbox · Admin' };

export default function Page() {
  return (
    <Suspense fallback={null}>
      <InboxClient />
    </Suspense>
  );
}
